export default __webpack_public_path__ + "static/media/author@2x.54ea7fec.png";